import api from '../axios.config';
import { API_ENDPOINTS, createEndpoint } from './endpoints';

export const PartnerService = {
  createPartner: async (data) => {
    const response = await api.post(API_ENDPOINTS.PARTNER.CREATE, data);
    return response;
  },

  listPartners: async ({
    page = 1,
    pageSize = 10,
    search = '',
    partnerType,
    includeInactive = false,
  } = {}) => {
    const endpoint = createEndpoint(API_ENDPOINTS.PARTNER.LIST, {
      search: search || undefined,
      partner_type: partnerType || undefined,
      include_inactive: includeInactive,
      page,
      pageSize,
    });

    const response = await api.get(endpoint);
    return response;
  },

  getPartnerDetail: async (orgId) => {
    const endpoint = createEndpoint(API_ENDPOINTS.PARTNER.GET, {
      org_id: orgId,
    });
    const response = await api.get(endpoint);
    return response;
  },

  getPartnerMembers: async ({
    orgId,
    page = 1,
    pageSize = 10,
    includeInactive = false,
  } = {}) => {
    const endpoint = createEndpoint(API_ENDPOINTS.PARTNER.GET_MEMBERS, {
      org_id: orgId,
      include_inactive: includeInactive,
      page,
      pageSize,
    });
    const response = await api.get(endpoint);
    return response;
  },

  addPartnerMember: async ({ orgId, data }) => {
    const endpoint = createEndpoint(API_ENDPOINTS.PARTNER.ADD_MEMBER, {
      org_id: orgId,
    });
    const response = await api.post(endpoint, data);
    return response;
  },
};
